module.exports = __webpack_public_path__ + "static/assets/cca0cdcaa25a0fd89c996cd64bb0ce39.svg";